import { render, staticRenderFns } from "./DeptStatistics.vue?vue&type=template&id=485f0ee0&scoped=true"
import script from "./DeptStatistics.vue?vue&type=script&lang=js"
export * from "./DeptStatistics.vue?vue&type=script&lang=js"
import style0 from "./DeptStatistics.vue?vue&type=style&index=0&id=485f0ee0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485f0ee0",
  null
  
)

export default component.exports